import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-206">
      <div className="max-w-3xl mx-auto text-center" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-208">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-209">
            Il vero costo della preparazione manuale
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-brand-cream mb-6 leading-tight" data-id="element-210">
            Quanto tempo stai{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-211">
              perdendo
            </span>
            , davvero?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-212">
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-4" data-id="element-213">
            Pianificare manualmente ogni lezione di Economia Aziendale ti toglie
            in media da{' '}
            <span className="text-brand-danger font-bold" data-id="element-214">
              3 a 5 ore a settimana
            </span>
            .
          </p>
          <p className="text-lg sm:text-xl text-brand-cream font-black leading-relaxed" data-id="element-215">
            Più di <span className="text-brand-danger" data-id="element-216">150 ore all'anno</span>.
            <br data-id="element-217" />
            Per sempre.
          </p>
        </motion.div>
      </div>
    </section>;
}